class ViewOffers extends HTMLElement {
  constructor() {
    super();

    this.showOffers = this.showOffers.bind(this);
    this.closeOffers = this.closeOffers.bind(this);
  };
  connectedCallback() {
    this.displayOffersButton = this.querySelector('.offers-button');
    this.offersContainer = this.querySelector('.offers-container');
    this.closeOffersButton = this.querySelector('.close-offers');

    if(this.displayOffersButton){
      this.displayOffersButton.addEventListener('click', this.showOffers);
    }

    if (this.closeOffersButton){
      this.closeOffersButton.addEventListener('click', this.closeOffers);
    }

    window.addEventListener('click', (event)=>{
      if(event.target.classList.contains('offers-container') && !event.target.classList.contains('offers-button')){
        this.closeOffers(event);
      }
    })
  }

  showOffers(event) {
    event.preventDefault();
    this.offersContainer.classList.remove('hide-offers');
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
  }

  closeOffers(event) {
    event.preventDefault();
    this.offersContainer.classList.add('hide-offers');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
  }

  disconnectedCallback() {
    if(this.displayOffersButton){
      this.displayOffersButton.removeEventListener('click', this.displayOffers);
    }

    if (this.closeOffersButton){
      this.closeOffersButton.removeEventListener('click', this.closeOffers);
    }
  }
}

customElements.define('view-offers', ViewOffers);